import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21a7c125"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value", "disabled"]
const _hoisted_2 = {
  key: 0,
  class: "label"
}

import { ref, computed } from 'vue'
import { Option, OptionValue } from '@/entities/rain/dropdown'
import { FontAwesomeIcon } from 'fontawesome/vue-fontawesome'
import { faChevronDown, faChevronUp } from 'fontawesome/free-solid-svg-icons'
import Checkbox from '@/components/Rain/Inputs/Checkbox.vue'

interface Props {
    options?: Option[]
    values?: OptionValue
    label?: string
    disabled?: boolean
    error?: boolean
    showLabel?: boolean
    floatingDropdown?: boolean
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DropdownMultiCheckbox',
  props: {
    options: { default: () => [] },
    values: { default: () => [] },
    label: { default: '' },
    disabled: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    showLabel: { type: Boolean, default: true },
    floatingDropdown: { type: Boolean, default: false }
  },
  emits: ['change'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const dropdownActive = ref(false)

const selectedOptionsLabels = computed(() => {
    return props.values.map((obj: Option) => obj.label).join(', ')
})

const isSelected = (option: Option) => {
    return props.values.some((obj: Option) => obj.value === option.value)
}

const selectOption = (option: Option, checked: boolean) => {
    emit('change', option, checked)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", {
      class: "dropdown-label",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (dropdownActive.value = !dropdownActive.value))
    }, [
      _createElementVNode("input", {
        class: _normalizeClass([
                    {
                        value: selectedOptionsLabels.value,
                        error: _ctx.error,
                        'show-label': _ctx.showLabel,
                    },
                ]),
        value: selectedOptionsLabels.value,
        disabled: _ctx.disabled,
        readonly: ""
      }, null, 10, _hoisted_1),
      (_ctx.showLabel)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.label), 1))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(_unref(FontAwesomeIcon), {
        class: _normalizeClass(["icon", [{ 'show-label': _ctx.showLabel }]]),
        icon: _unref(faChevronUp)
      }, null, 8, ["class", "icon"]), [
        [_vShow, dropdownActive.value]
      ]),
      _withDirectives(_createVNode(_unref(FontAwesomeIcon), {
        class: _normalizeClass(["icon", [{ 'show-label': _ctx.showLabel }]]),
        icon: _unref(faChevronDown)
      }, null, 8, ["class", "icon"]), [
        [_vShow, !dropdownActive.value]
      ])
    ]),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass([
                'multi-checkbox-container',
                { 'floating-dropdown': _ctx.floatingDropdown, error: _ctx.error },
            ])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
        return (_openBlock(), _createBlock(Checkbox, {
          key: option.value,
          checked: isSelected(option),
          onChange: ($event: any) => (selectOption(option, $event))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(option.label), 1)
          ], undefined, true),
          _: 2
        }, 1032, ["checked", "onChange"]))
      }), 128))
    ], 2), [
      [_vShow, dropdownActive.value]
    ])
  ]))
}
}

})